import env from '../env';

const scraper = {
  maxRequestsPerCrawl: env.isDevelopment ? 1000 : 5_000,
  maxRequestsPerMinute: env.isDevelopment ? 100 : 300,
  maxConcurrency: env.isDevelopment ? 5 : 50,
};

export default scraper;
